// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"779":"fancyappscss","979":"swiper"}[chunkId] + "." + chunkId + "." + {"779":"b32cfe44ef34ceb66e0c","979":"5cb7b2d79305d21fdb57"}[chunkId] + ".css";
};